import Vue from 'vue'

const data = Vue.observable({
  shouldReFetch: false,
  fetched: false
})

export default {
  methods: {
    /**
     * @param {boolean} val
     */
    setShouldOrdersReFetch (val) {
      data.shouldReFetch = val
    },

    /**
     *
     * @param {boolean} val
     */
    setOrdersFetched (val) {
      data.fetched = val
    }
  },

  computed: {
    shouldReFetchOrdersGetters () {
      return {
        shouldReFetch: data.shouldReFetch,
        fetched: data.fetched
      }
    }
  }
}
